// Action Types

export const Types = {
  GET_ALL_MY_PLANNER_TASKS_REQUESTED: 'tasks/GET_ALL_MY_PLANNER_TASKS_REQUESTED',
  GET_ALL_MY_PLANNER_TASKS_SUCCEEDED: 'tasks/GET_ALL_MY_PLANNER_TASKS_SUCCEEDED',
  GET_ALL_MY_PLANNER_TASKS_FAILED: 'tasks/GET_ALL_MY_PLANNER_TASKS_FAILED',
}

// Action Creators

export function getAllMyPlannerTasks() {
  return {
    type: Types.GET_ALL_MY_PLANNER_TASKS_REQUESTED,
  }
}

// Reducer

const INITIAL_STATE = {
  getAllMyPlannerTasksIsLoading: false,
  getAllMyPlannerTasksError: null,
  myPlannerTasks: null,
}

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.GET_ALL_MY_PLANNER_TASKS_REQUESTED:
      return {
        ...state,
        getAllMyPlannerTasksIsLoading: true,
      }
    case Types.GET_ALL_MY_PLANNER_TASKS_SUCCEEDED:
      return {
        ...state,
        getAllMyPlannerTasksIsLoading: false,
        getAllMyPlannerTasksError: null,
        myPlannerTasks: action.payload,
      }
    case Types.GET_ALL_MY_PLANNER_TASKS_FAILED:
      return {
        ...state,
        getAllMyPlannerTasksIsLoading: false,
        getAllMyPlannerTasksError: action.payload,
        myPlannerTasks: null,
      }

    default:
      return state
  }
}
